import { FormSection } from 'framework/ui/layout';
import { UPDATE_EMPLOYEE_MILITARY_INFO } from 'domain/shared/employee';
import PrepopulationWrapper from 'domain/people/employee/prepopulation/PrepopulationWrapper';
import MilitaryInput from 'domain/people/employee/shared/input/MilitaryInput';
import { FC } from 'react';
import { FormFieldsData } from 'validation-schema-library/build/validation/types';

type MilitaryInfoUpdateSectionProps = {
  isGranted: (permission: string) => boolean;
  isNotPolishOffice: (formData: FormFieldsData) => boolean;
};
const MilitaryInfoUpdateSection: FC<MilitaryInfoUpdateSectionProps> = ({ isGranted, isNotPolishOffice }) => {
  return (
    <FormSection title="Military information" isVisible={isGranted(UPDATE_EMPLOYEE_MILITARY_INFO) && isNotPolishOffice}>
      <PrepopulationWrapper>
        <MilitaryInput source="extendedInformation.militaryRecord" />
      </PrepopulationWrapper>
    </FormSection>
  );
};

export { MilitaryInfoUpdateSection };
